import { serialize } from "object-to-formdata";
import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/dist/query";

import QueryTags from "api/types/QueryTags";
import FileUpload from "api/types/models/upload";
import { UploadFileRequest } from "api/types/requests";

const fileEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  uploadFile: builder.mutation<FileUpload, UploadFileRequest>({
    query: (body) => ({
      url: "/files",
      method: "post",
      body: serialize(body),
    }),
  }),

  deleteFile: builder.mutation<void, number>({
    query: (id) => ({
      url: `/files/${id}`,
      method: "delete",
    }),
  }),
});

export default fileEndpoints;
